import "./Logo.css"
import React from "react";
import {observer} from "mobx-react-lite";

function Logo() {
    return (<>
        <div className={"logo"}>
            SCRAPIN
        </div>
    </>)
}

export default observer(Logo)